<template>
    <div>
        <CommonPopupFrame :changeHeight="70" :changeBottom="0" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; position: relative">
                <div @click="closeCompleteAction">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
                <div @click="setModifyEnterType" style="font-weight: 700; color: var(--color-main);">적용</div>
                <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">참여 형태 바꾸기</div>
            </div>
            <div style="flex: 1; background-color: #f5f5f5; padding: 16px 20px;">
                <div style="position: relative;">
                    <div style="position: relative; z-index: 2;" class="common_box">
                        <div style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #ebebeb; padding-bottom: 12px;">
                            <div style="font-weight: 700; font-size: 14px;">비공개</div>
                            <!-- <div @click="modifyEnterType" style="width:80px;display:flex; flex-direction: row-reverse; align-items: center;">
                                <a class="switch" :class="{ active: switchOn }"><span></span></a>
                            </div> -->
                            <CommonSwitch :switchClickEvent="modifyEnterType" :isOn="switchOn"></CommonSwitch>
                        </div>
                        <div v-if="!switchOn" style="padding-top: 12px;">
                            <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 6px;">
                                <img style="width: 11px;" :src="require('@/assets/img/anybody_select.png')" alt="">
                                <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">누구나 참여 가능</div>
                            </div>
                            <div style="font-weight: 500; font-size: 12px; color: #606060;">누구든 멤버톡에 참여할 수 있습니다.</div>
                        </div>
                        <div v-else style="padding-top: 12px;">
                            <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 6px;">
                                <img style="width: 11px;" :src="require('@/assets/img/private.png')" alt="">
                                <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">비공개</div>
                            </div>
                            <div style="font-weight: 500; font-size: 12px; color: #606060;">초대 혹은 비밀번호 입력 시 참여할 수 있습니다.</div>
                        </div>
                    </div>
                    <div :style="{ transform: switchOn ? 'translateY(16px)' : 'translateY(-100%)' }" style="transition: all 0.2s;">
                        <div @click="setIsOpenModifyHintCode" :style="{opacity: switchOn ? '1' : '0'}" style="transition: all 0.2s; font-weight: 500; font-size: 14px; color: var(--color-main); line-height: 24px; margin-bottom: 2px; text-align: right;">변경</div>
                        <div style="display: flex; justify-content: space-between; margin-bottom: 16px;" class="common_box">
                            <div style="font-weight: 700; font-size: 14px;">입장 코드 힌트</div>
                            <div style="font-weight: 700; font-size: 14px; color: #606060">{{ memberTalkDetail.password_hint }}</div>
                        </div>
                        <div style="display: flex; justify-content: space-between;" class="common_box">
                            <div style="font-weight: 700; font-size: 14px;">입장 코드</div>
                            <div style="font-weight: 700; font-size: 14px; color: #606060">{{ memberTalkDetail.password }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
        <CommonPopupFrame :changeHeight="50" :changeBottom="0" :isOpen="isOpenModifyHintCode" :closeCompleteAction="closeModifyHintCode">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; position: relative">
                <div @click="closeModifyHintCode">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
                <div @click="savePrivateInfo" style="font-weight: 700; color: var(--color-main);">적용</div>
                <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">입장 코드 변경</div>
            </div>
            <div style="flex: 1; background-color: #f5f5f5; padding: 16px 20px;">
                <div style="margin-bottom: 32px;">
                    <div class="title">멤버톡 입장 코드 힌트를 입력해주세요</div>
                    <input v-model="passwordHint" placeholder="예 : 맨체스터 시티 구단의 창단 년도" class="common_input" type="text">
                </div>
                <div style="margin-bottom: 32px;">
                    <div class="title">암호를 설정해주세요</div>
                    <input v-model="password" placeholder="숫자만 입력 가능" class="common_input" type="tel">
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame';
import CommonSwitch from '@/components/common/CommonSwitch';
import ResponseCode from '../../../ResponseCode';
import { JOIN_WAY } from '../../../Constants';
export default {
    name: 'ModifyMemberTalkEnterType',
    components: { CommonPopupFrame, CommonSwitch },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        memberTalkDetail: {
            type: Object,
            default: () => { }
        },
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        }
    },
    data() {
        return {
            switchOn: null,
            JOIN_WAY: JOIN_WAY,
            isOpenModifyHintCode: false,
            passwordHint: '',
            password: ''
        }
    },
    created() {
        if (this.memberTalkDetail.join_way === JOIN_WAY.APPROVE) {
            this.switchOn = true
        } else {
            this.switchOn = false
        }

        console.log(this.memberTalkDetail)
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                if (this.memberTalkDetail.join_way === JOIN_WAY.APPROVE) {
                    this.switchOn = true
                } else {
                    this.switchOn = false
                }
            }
        }
    },
    methods: {
        setIsOpenModifyHintCode() {
            this.isOpenModifyHintCode = true
            this.passwordHint = this.memberTalkDetail.password_hint
        },
        closeModifyHintCode() {
            this.isOpenModifyHintCode = false
        },
        modifyEnterType() {
            this.switchOn = !this.switchOn
        },
        async setModifyEnterType(isModifyHintCode) {
            let join_way = this.switchOn ? JOIN_WAY.APPROVE : JOIN_WAY.ANYBODY
            const formData = new FormData()
            formData.append('mode', 'update')
            formData.append('join_way', join_way)
            formData.append('join_idx', this.memberTalkIdx)

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeCompleteAction('join_way', join_way)
                if (isModifyHintCode) {
                    console.log(this.passwordHint)
                    this.closeCompleteAction('password_hint', this.passwordHint)
                    this.passwordHint = ''
                    this.password = ''
                }
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async savePrivateInfo() {
            const formData = new FormData()
            formData.append('mode', 'update')
            formData.append('join_idx', this.memberTalkIdx)
            formData.append('password_hint', this.passwordHint)
            formData.append('password', this.password)
            const res = await this.$Axios.post('/api/join/save', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.setModifyEnterType(true)
                this.isOpenModifyHintCode = false
                // this.$GlobalStore.addModal('MemberTalkDetailSetting', {memberTalkIdx: this.memberTalkIdx})
            } else {
                console.log(res.data.msg)
            }
        }
    }
}
</script>

<style scoped>
.switch {
    display: inline-block;
    width: 46px;
    height: 27px;
    border-radius: 14px;
    background: #C7C7C7;
    position: relative;
    transition: background-color 0.3s;
    animation-timing-function: ease-out;
}

.switch span {
    width: 23px;
    height: 23px;
    border-radius: 50%;
    background: #ffffff;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: left 0.3s;
    animation-timing-function: ease-out;
}

.switch.active {
    background: var(--color-main);
}

.switch.active span {
    left: 21px;
}

.common_box {
    background-color: #fff;
    padding: 12px;
    border-radius: 12px;
}

.title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
}

.common_input {
    padding: 10px;
    padding-left: 12px;
    border: none;
    width: 100%;
    border-radius: 12px;
    background-color: #fff;
    outline: none;
}

.common_input::placeholder {
    color: #bbbbbb;
    font-weight: 700;
    font-size: 14px;
}
</style>